// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__15nK6","buttons":"PendingPaymentAlert_buttons__1bMLQ"};